import { render, staticRenderFns } from "./terms_wrapper.vue?vue&type=template&id=554f13ac"
import script from "./terms_wrapper.vue?vue&type=script&lang=js"
export * from "./terms_wrapper.vue?vue&type=script&lang=js"
import style0 from "./terms_wrapper.vue?vue&type=style&index=0&id=554f13ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports